module.exports = __webpack_public_path__ + "img/study.9cb4de62.png";